import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { clientUrls } from 'ui-toolkit/rest/ClientUrlFactory';
import { setRedirectTarget } from './redirectTargetSlice';
import { eAccessControlUserType } from '../../ui-toolkit/enums/eAccessControlUserType';
import { useAppDispatch } from '../store';

// Some users when logged out will manually type `/spa/admin`, `/spa/client`, `/spa/vendor` into the address bar.
// This regex matches those cases.
// If a match is found, the user is redirected to their orders page.
const basePattern = /^\/spa\/(admin|vendor|client)\/?$/;

export const useLoginRedirect = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  return useCallback(
    (userType: eAccessControlUserType) => {
      const newUrl = clientUrls.urlFor.spaLogin(userType);
      const oldUrl = history.location.pathname;
      if (basePattern.test(oldUrl)) {
        dispatch(setRedirectTarget(clientUrls.urlFor.ordersPage(userType)));
      } else {
        dispatch(setRedirectTarget(oldUrl));
      }
      history.push(newUrl);
    },
    [history, dispatch]
  );
};
